module.exports = __webpack_public_path__ + "img/interior.c49f2597.webp";